import angular from 'angular';
import _ from 'underscore';
import jQuery from 'jquery';
import moment from 'moment';

function ManageGuestlistsCtrl($scope, $state, $stateParams, $timeout, $location, $q, eventService, sdkUtils, admissionGroupService, inventoryService, modalService, pubsubService, permissionService, dateUtilsService, alertService, managementUserService, organizationService, managementUserOrganizationMemberService, userPreferencesService, $sce, reportService) { //eslint-disable-line
  const currentUser = managementUserService.getCurrentUser();
  const currentUserOrganization = organizationService.getCurrentOrganization();

  userPreferencesService.setManagePage('ADMISSIONS');

  _initScope();

  function _initScope() {
    $scope.loading = true;
    $scope.stats = {};

    $scope.isExternalOrganization = function() {
      return $scope.venue ? permissionService.isExternalOrganization($scope.venue.organization) : false;
    };

    $scope.canPerformActions = () => {
      return !$scope.isExternalOrganization() && $scope.canWrite;
    };
    $scope.canWrite = false;

    $scope.selectedSuggestion = null;

    /**
     * @desc Form for the Guestlist search box
     */
    $scope.guestlistFilterForm = {
      searchTerm: null
    };

    $scope.getAdmissionGroupNotes = function(admissionGroup) {
      let notes = `<div>${admissionGroup.notes || ''}`;

      if (admissionGroup.status === 'CANCELLED' && admissionGroup.cancelledNote) {
        if (notes !== '') notes += '<br><br>';
        notes += `<p><strong>Cancelled Notes:</strong></p><p>${admissionGroup.cancelledNote}</p>`;
      }

      notes += '</div>';

      return $sce.trustAsHtml(notes);
    };

    $scope.guestListDataTableOptions = {
      paginationType: 'full_numbers',
      displayLength: 50,
      columnDefs: [{
        visible: false,
        targets: 0
      }],
      order: [
        [0, 'asc']
      ],
      drawCallback: function() {
        const api = this.api();
        const rows = api.rows({
          page: 'current'
        }).nodes();
        let last = null;

        api.column(0, {
          page: 'current'
        }).data().each((group, i) => {
          if (last !== group) {
            jQuery(rows).eq(i).before(
              `<tr class="divider"><td colspan="11">${group}</td></tr>`
            );

            last = group;
          }
        });
      }
    };

    $scope.guestListDataTableInstance = {};
    $scope.guestListDataTableInstanceCallback = function(dtInstance) {
      $scope.guestListDataTableInstance = dtInstance;
    };

    /**
     * @desc on-keyup handler for the search box
     */
    $scope.filterGuestlist = function filterGuestlist() {
      if ($scope.guestListDataTableInstance && $scope.guestListDataTableInstance.DataTable) {
        $scope.guestListDataTableInstance.DataTable.search($scope.guestlistFilterForm.searchTerm).draw();
      }
    };

    $scope.venuesPromise
      .then(() => {
        $q.all([
            _getPermissions(),
            _getInventory(),
            _getAdmissionGroups()
          ])
          .then(() => {
            $scope.loading = false;

            if ($stateParams.admissionGroupId) {
              const foundAdmisionGroup = _.findWhere($scope.admissionGroups, {
                id: $stateParams.admissionGroupId
              });
              if (foundAdmisionGroup) $scope.updateAdmissionGroup(foundAdmisionGroup);
            }
          });
      });

    $scope.addAdmissionGroup = _addAdmissionGroup;
    $scope.updateAdmissionGroup = _updateAdmissionGroup;
    $scope.addBulkAdmissionGroups = _addBulkAdmissionGroups;
    $scope.exportData = _exportData;
    $scope.filterGuestlists = function(doc) {
      return doc.type !== 'TALLY' && doc.status !== 'CANCELLED';
    };
    $scope.checkboxForm = {
      selectAll: false
    };
    $scope.$watch('checkboxForm.selectAll', () => {
      if ($scope.checkboxForm.selectAll) {
        $scope.admissionGroups.forEach(admissionGroup => {
          admissionGroup.selected = true;
        });
      } else {
        if (!$scope.admissionGroups || !$scope.admissionGroups.length) return;

        let allchecked = true;

        $scope.admissionGroups.forEach(admissionGroup => {
          if (allchecked && !admissionGroup.selected) {
            allchecked = false;
          }
        });

        if (allchecked) {
          $scope.admissionGroups.forEach(admissionGroup => {
            admissionGroup.selected = false;
          });
        }
      }
    });
    $scope.deleteSelected = function($event) {
      if ($event) $event.preventDefault();

      const admissionGroupIds = getSelectedAdmissionGroupIds();

      if (!admissionGroupIds || !admissionGroupIds.length) {
        alert('Please select some guestlists to delete'); //eslint-disable-line

        return;
      }

      modalService.confirmation({
          modalHeader: 'Delete Guestlists',
          modalMessage: `Are you sure you want to delete these ${admissionGroupIds.length} ${admissionGroupIds.length > 1 ? 'guestlists' : 'guestlist'}?`,
          confirmBtnTxt: 'Delete',
          confirmingBtnTxt: 'Deleting...',
          size: 'sm'
        })
        .then(result => {
          if (result && result.confirm) {
            admissionGroupService.performAction({
                type: 'BULK_DELETE',
                ids: admissionGroupIds
              })
              .then(() => {
                admissionGroupIds.forEach(id => {
                  const guestlist = _.find($scope.admissionGroups, {
                    _id: id
                  });

                  if (guestlist) {
                    const index = $scope.admissionGroups.indexOf(guestlist);

                    $scope.admissionGroups.splice(index, 1);
                  }
                });

                alertService.success('Guestlists deleted');
              })
              .catch(response => {
                alertService.error(sdkUtils.getErrorFromResponse(response));
              })
              .finally(() => {
                result.modalInstance.close();
              });
          }
        })
        .catch(error => {
          console.log(error);
        });
    };

    pubsubSubscribe();
  }

  function _getPermissions() {
    const canWrite = permissionService.canWriteGuestlists($scope.venue.id);

    return $q.all({
      canWrite
    }).then(results => {
      $scope.canWrite = results.canWrite;
    });
  }

  function pubsubSubscribe() {
    const reservationChannel = `${pubsubService.CHANNELS.NP_COMPANY_GUESTLIST}${currentUserOrganization.id}`;

    if (!$scope.isExternalOrganization()) {
      $scope.pubsubReservationClient = pubsubService.subscribe(reservationChannel, message => {
        if (!$scope.venue) return;

        //ignore messages from the same person
        if (message.userId !== currentUser.id && message.venueId === $scope.venue.id) {
          const messageDate = moment.utc(message.date);

          if (message.type === 'GUEST_LIST' && messageDate.format('DD-MM-YY') === moment($scope.currentDateUTC).format('DD-MM-YY')) {
            _handlePubsub(message.admissionGroupId);
          }
        }
      });
    }

    $scope.$on('$destroy', () => {
      $scope.pubsubReservationClient.unsubscribe({
        channels: [reservationChannel]
      });
    });
  }

  function _exportData($event) {
    if ($event) $event.preventDefault();

    const options = {
      fileType: 'CSV',
      organizationId: currentUserOrganization.id,
      reportType: 'TLPRO_ADMISSION_DUMP',
      dateStart: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
      dateEnd: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC)
    };

    const admissionGroupIds = getSelectedAdmissionGroupIds();

    if ($scope.event) {
      options.eventId = $scope.event.id;
    }

    if ($scope.venue) {
      options.venueId = $scope.venue.id;
    }

    if (admissionGroupIds.length) {
      options.admissionGroupId = admissionGroupIds;
    }

    return reportService.create(options);
  }

  function _addBulkAdmissionGroups(type, $event) {
    if (!type) throw new Error('_addBulkAdmissionGroups() - type is required');
    if ($event) $event.preventDefault();

    modalService.bulkAddAdmissionGroup({
        type: 'GUEST_LIST',
        date: $scope.currentDateUTC,
        venue: $scope.venue,
        eventId: $scope.event ? $scope.event.id : null,
        organizationId: currentUserOrganization.id,
        modalHeader: 'Add Guests in Bulk',
        inventory: $scope.inventory,
        bulkUploadType: type
      })
      .then(function(result) {
        if (!result || !result.admissionGroups) return;

        $scope.admissionGroups = $scope.admissionGroups.concat(result.admissionGroups);

        alertService.success(result.admissionGroups.length + ' new Guestlist' + (result.admissionGroups.length === 1 ? ' has' : 's have') + ' been added.'); //eslint-disable-line
      })
      .catch(() => {
        alertService.error('There was an error creating or updating an admission group');
      });
  }

  function _updateAdmissionGroup(admissionGroup, $event) {
    if (!admissionGroup) return;

    if ($event) $event.preventDefault();

    modalService.addAdmissionGroup({
      type: 'GUEST_LIST',
      admissionGroup: admissionGroup,
      date: $scope.currentDateUTC,
      venue: $scope.venue,
      eventId: $scope.event ? $scope.event.id : null,
      events: $scope.events,
      organizationId: currentUserOrganization.id,
      onAddedOrUpdated: function(result) {
        if (!result || !result.admissionGroup) return;

        if (result.deleted) {
          const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
            id: result.admissionGroup.id
          });

          const index = $scope.admissionGroups.indexOf(existingAdmissionGroup);

          $scope.admissionGroups.splice(index, 1);
        } else if (!result.created) {
          const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
            id: result.admissionGroup.id
          });

          if (result.admissionGroup.date !== existingAdmissionGroup.date) {
            //remove the admission group because it's date changed
            const index = $scope.admissionGroups.indexOf(existingAdmissionGroup);
            $scope.admissionGroups.splice(index, 1);

            const admissionGroupDate = moment.utc(result.admissionGroup.date, 'x');

            modalService.admissionGroupNotVisible({
              modalHeader: `Guestlist date has been changed to ${admissionGroupDate.format('ddd. MMMM Do')} and is no longer visible.`,
              onBtnClick: function() {
                $state.go($state.current.name, {
                  date: result.admissionGroup.date,
                  venueId: $scope.venueId
                }, {
                  reload: true
                });
              }
            });
          } else if (existingAdmissionGroup) {
            _.extend(existingAdmissionGroup, result.admissionGroup);
          }
        } else {
          $scope.admissionGroups.push(result.admissionGroup);
        }

        _mapAdmissionGroups();

        $scope.admissionGroups = angular.copy($scope.admissionGroups); //needed to force datatables to fully redraw

        alertService.success(result.deleted ? 'Guestlist deleted' : 'Guestlist saved');
      }
    });
  }

  function _addAdmissionGroup($event) {
    if ($event) $event.preventDefault();

    $scope.currentAdmissionGroup = null;

    $scope.selectedSuggestion = null;

    modalService.addAdmissionGroup({
      type: 'GUEST_LIST',
      date: $scope.currentDateUTC,
      venue: $scope.venue,
      eventId: $scope.event ? $scope.event.id : null,
      events: $scope.events,
      organizationId: currentUserOrganization.id,
      addedBy: currentUser.id,
      onAddedOrUpdated: function(result) {
        if (!result || !result.admissionGroup) return;

        if (!result.created) {
          const existingAdmissionGroup = _.findWhere($scope.admissionGroups, {
            id: result.admissionGroup.id
          });

          if (existingAdmissionGroup) _.extend(existingAdmissionGroup, result.admissionGroup);
        } else {
          $scope.admissionGroups.push(result.admissionGroup);
        }

        _mapAdmissionGroups();

        alertService.success('Guest saved');
      }
    });
  }

  function getSelectedAdmissionGroups() {
    return _.where($scope.admissionGroups, {
      selected: true
    });
  }

  function getSelectedAdmissionGroupIds() {
    const selectedAdmissionGroups = getSelectedAdmissionGroups();
    return _.map(selectedAdmissionGroups, group => group.id);
  }

  function _getAdmissionGroups() {
    const options = {
      venue: $scope.venueId,
      limit: 3000,
      event: $scope.event ? $scope.event.id : null,
      dateStart: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
      dateEnd: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
      type: [
        'GUEST_LIST',
        'TICKET',
        'TALLY'
      ]
    };

    return admissionGroupService.list(options)
      .then(function(admissionGroups) {
        $scope.admissionGroups = admissionGroups;

        _mapAdmissionGroups();
      })
      .catch(function(error) {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _getInventory() {
    return inventoryService.list({
        venueId: $scope.venueId,
        eventId: $scope.event ? $scope.event.id : null,
        start: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
        end: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
        type: 'COVER'
      })
      .then(inventory => {
        $scope.inventory = inventory;

        for (let i = 0; i < inventory.length; i++) { //eslint-disable-line
          const cover = inventory[i];

          if (cover.location && !cover.deleted && cover.type === 'COVER') {
            jQuery('#bulk-guest-cover-field').append('<option value="' + cover.id + '" data-cover-price="' + cover.price + '" data-cover-id="' + cover.id + '" data-cover-type="' + cover.location + '">' + cover.name + ' ($' + cover.price + ')</option>'); //eslint-disable-line
            jQuery('#excel-guest-cover-field').append('<option value="' + cover.id + '" data-cover-price="' + cover.price + '" data-cover-id="' + cover.id + '" data-cover-type="' + cover.location + '">' + cover.name + ' ($' + cover.price + ')</option>'); //eslint-disable-line
          }
        }
      })
      .catch(function(error) {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _mapAdmissionGroups() {
    _.map($scope.admissionGroups, admissionGroup => {
      admissionGroup.full_name = admissionGroup.name;

      if (admissionGroup.event) {
        const event = $scope.eventsIndexedById[admissionGroup.event];
        admissionGroup.eventName = event ? event.name : 'No Event';
      } else {
        admissionGroup.eventName = 'No Event';
      }

      if (admissionGroup.inventory) {
        const cover = _.find($scope.inventory, function(r) {
          return r.id === admissionGroup.inventory;
        });

        if (cover) {
          admissionGroup.cover_type = cover.location;
          admissionGroup.cover_id = cover.id;
          admissionGroup.cover_price = cover.price;
        }
      }

      if (admissionGroup.addedBy) {
        admissionGroup.addedByDetails = _.find($scope.users, function(r) {
          return r.id === admissionGroup.addedBy;
        });
      }

      admissionGroup.fullNotes = $scope.getAdmissionGroupNotes(admissionGroup);
    });

    $scope.getAdmissionGroupStatsThrottled();
  }

  function _handlePubsub(admissionGroupId) {
    admissionGroupService.readById(admissionGroupId)
      .then(admissionGroup => {
        const foundAdmisionGroup = _.findWhere($scope.admissionGroups, {
          id: admissionGroup.id
        });

        if (foundAdmisionGroup) {
          angular.extend(foundAdmisionGroup, admissionGroup);
        } else if ($scope.admissionGroups) {
          $scope.admissionGroups.unshift(admissionGroup);
        }

        _mapAdmissionGroups();

        //if it was added by the current user don't show the alert
        if (admissionGroup.addedBy && admissionGroup.addedByDetails && admissionGroup.addedBy === currentUser.id) return;

        if (!foundAdmisionGroup) {
          if (admissionGroup.addedBy && admissionGroup.addedByDetails) {
            alertService.success(admissionGroup.name + " was just added by " + admissionGroup.addedByDetails.first_name + " " + admissionGroup.addedByDetails.last_name); //eslint-disable-line
          } else {
            alertService.success(admissionGroup.name + " was just added."); //eslint-disable-line
          }
        } else {
          alertService.success(admissionGroup.name + " was just updated."); //eslint-disable-line
        }
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }
}

ManageGuestlistsCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$timeout',
  '$location',
  '$q',
  'jsSdk.event',
  'jsSdk.utils',
  'jsSdk.admissionGroup',
  'jsSdk.inventory',
  'modalService',
  'pubsubService',
  'permissionService',
  'dateUtilsService',
  'alertService',
  'jsSdk.managementUser',
  'organizationService',
  'managementUserOrganizationMemberService',
  'userPreferencesService',
  '$sce',
  'reportService'
];

export default ManageGuestlistsCtrl;



// WEBPACK FOOTER //
// ./src/components/manageGuestlists/manageGuestlistsCtrl.js